import moment from 'moment'

export function getStatusLabel(filterParams, __, T) {
  const { statuses } = filterParams
  let label = `${__(T.fields.status)}: `
  if (!statuses) {
    label = __(T.fields.status)
  } else {
    label += statuses
  }
  return label
}

export function getTabOptions(filterParams, dateLabel, __, T) {
  let datePillLabel = ''
  if (dateLabel === 'today') datePillLabel = `${__(T.fields.date)}: ${__(T.misc.today)}`
  else if (dateLabel === 'lastweek') datePillLabel = `${__(T.fields.date)}: ${__(T.misc.lastweek)}`
  else if (dateLabel === 'all' || !dateLabel) datePillLabel = `${__(T.fields.date)}`
  else datePillLabel = dateLabel // stringa delle date
  return [
    {
      label: datePillLabel,
      hasMenu: true,
      id: 'date',
      filled: !!filterParams.creationDateStart || !!filterParams.creationDateEnd
    },
    {
      label: getStatusLabel(filterParams, __, T),
      hasMenu: true,
      id: 'status',
      filled: !!filterParams.statuses
    }
  ]
}

export function dateOptions(filterParams, setFilterParamsAndLabel, fetch, Navigator, __, T) {
  const all = {
    label: __(T.misc.all),
    value: 'all'
  }
  const today = {
    label: __(T.misc.today),
    value: 'today'
  }
  const lastWeek = {
    label: __(T.misc.lastweek),
    value: 'lastweek'
  }
  const specific = {
    label: __(T.misc.specific),
    value: 'specific'
  }
  return { all, today, lastWeek, specific }
}

export function statusOptions(filterParams, setFilterParamsAndLabel, fetch, Navigator, __, T) {
  const all = {
    label: 'ALL',
    value: 'all'
  }
  const inbound = {
    label: 'INBOUND',
    value: 'IN_INBOUND'
  }
  const draft = {
    label: 'DRAFT',
    value: 'DRAFT'
  }
  const received = {
    label: 'RECEIVED',
    value: 'RECEIVED'
  }
  const outbound = {
    label: 'OUTBOUND',
    value: 'IN_OUTBOUND'
  }
  const outboundError = {
    label: 'OUTBOUND ERROR',
    value: 'OUTBOUND_ERROR'
  }
  const inboundError = {
    label: 'INBOUND ERROR',
    value: 'INBOUND_ERROR'
  }
  const inTransit = {
    label: 'IN TRANSIT',
    value: 'IN_TRANSIT'
  }
  return { all, inbound, draft, received, outbound, outboundError, inboundError, inTransit }
}

export function getDateModalOptions(filterParams, setFilterParamsAndLabel, fetch, Navigator, __, T) {
  const opts = dateOptions(filterParams, setFilterParamsAndLabel, fetch, Navigator, __, T)
  return [opts.today, opts.lastWeek, opts.specific]
}

export function getStatusModalOptions(
  filterParams,
  setFilterParamsAndLabel,
  fetch,
  Navigator,
  { __, T, currentDateLabel, operationConfig }
) {
  const opts = statusOptions(filterParams, setFilterParamsAndLabel, fetch, Navigator, __, T)
  if (operationConfig.type === 'INBOUND') {
    return [opts.all, opts.inbound, opts.inTransit, opts.draft, opts.received, opts.inboundError]
  } else if (operationConfig.type === 'OUTBOUND') {
    return [opts.all, opts.outbound, opts.draft, opts.received, opts.outboundError]
  }
  return [
    opts.all,
    opts.inbound,
    opts.inTransit,
    opts.outbound,
    opts.draft,
    opts.received,
    opts.inboundError,
    opts.outboundError
  ]
}

export function getModalOptionsByTab(
  tabId,
  { filterParams, setFilterParamsAndLabel, fetch, Navigator, __, T, currentDateLabel, operationConfig }
) {
  if (tabId === 'date') {
    return getDateModalOptions(filterParams, setFilterParamsAndLabel, fetch, Navigator, __, T)
  }
  if (tabId === 'status') {
    return getStatusModalOptions(filterParams, setFilterParamsAndLabel, fetch, Navigator, {
      __,
      T,
      currentDateLabel,
      operationConfig
    })
  }
  return []
}

export function getResetFilterByTab(tabId, filterParams) {
  if (tabId === 'date') {
    return {
      ...filterParams,
      creationDateStart: undefined,
      creationDateEnd: undefined
    }
  }
  if (tabId === 'status') {
    return {
      ...filterParams,
      statuses: undefined
    }
  }
  return filterParams
}

export function getDateSelectOptions(__, T) {
  const opts = dateOptions({}, () => {}, null, null, __, T)
  return Object.values(opts).map((opt) => ({ label: opt.label, value: opt.value }))
}

export const filtersConfig = [
  {
    key: 'statuses',
    type: 'select',
    label: (__, T) => __(T.fields.status),
    getOptions: (filters, __, T) =>
      Object.values(statusOptions(filters, undefined, null, null, __, T)).map((opt) => ({
        label: opt.label,
        value: opt.value
      })),
    multiple: true
  },
  {
    key: 'creationDate',
    type: 'date',
    label: (__, T) => __(T.fields.creation_date),
    getOptions: (filters, __, T) => getDateSelectOptions(__, T),
    multiple: false
  }
]
